export default {"src":"/_next/static/media/driedfruit.beb7569b.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};